import { NavCtas } from 'approot/shared/layout/navigation/navigation.style';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { pushNavFollowDataEvent } from './navigation.utils';
import {
  openChooseUserJoinModal,
  openChooseUserSignInModal,
} from 'approot/global-notifications/global-notification.utils';

const NavigationCtas = () => {
  return (
    <NavCtas>
      <SecondaryButton
        data-selector="header-menu-sign-in"
        onClick={() => {
          pushNavFollowDataEvent('Sign In');
          openChooseUserSignInModal();
        }}
      >
        Sign In
      </SecondaryButton>
      <PrimaryButton
        variant="default"
        data-selector="header-menu-join"
        onClick={() => {
          pushNavFollowDataEvent('Join');
          openChooseUserJoinModal();
        }}
      >
        Join
      </PrimaryButton>
    </NavCtas>
  );
};

export default NavigationCtas;
